import React, { useState } from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { GroupPlayerProps, GroupProps, MyPlayerProps } from '../../types';
import { GroupApi } from '../api';

type GroupPlayerActionFormProps = {
    me?:MyPlayerProps,
    group:GroupProps,
    group_player?:GroupPlayerProps,
    onRequestAuthenticate: () => void,
    onResponse:(gp:GroupPlayerProps) => void,
    onClose:() => void
}
const GroupPlayerActionForm = ({ me, group, group_player, onResponse, onRequestAuthenticate, onClose }:GroupPlayerActionFormProps) => {
    const [ action_loading, setActionLoading ] = useState(false);
    
    const handleAccept = async() => {
        if(!group_player){ return }
        setActionLoading(true)
        const new_gp = await GroupApi.acceptInvite(group_player.group_player_id);
        if(!new_gp){ alert('Unable to process') }
        else {
            onResponse(new_gp);
        }
        setActionLoading(false)
    }

    const handleDecline = async() => {
        if(!group_player){ return }
        setActionLoading(true)
        const new_gp = await GroupApi.declineInvite(group_player.group_player_id);
        if(!new_gp){ alert('Unable to process') }
        else {
            onResponse(new_gp);
        }
        setActionLoading(false)
    }

    const handleJoin= async() => {
        setActionLoading(true)
        const new_gp = await GroupApi.join(group.group_id);
        if(!new_gp){ alert('Unable to process') }
        else {
            onResponse(new_gp);
        }
        setActionLoading(false)
    }

    const handleLeave = async() => {
        if(!group_player){ return }
        setActionLoading(true)
        const new_gp = await GroupApi.leave(group_player.group_player_id);
        if(!new_gp){ alert('Unable to process') }
        else {
            onResponse(new_gp);
        }
        setActionLoading(false)
    }
    return (
        <View float>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <View transparent style={{ flex:1, marginRight:10 }}>
                    <Text theme='h1'>{group.name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{group.description}</Text>
                </View>
                <Button
                    title='X'
                    float
                    style={{ padding:10 }}
                    onPress={() => onClose()}
                />
            </View>
            <View type='body' style={{ padding:10 }}>
                {group_player ?
                <View>
                    {group_player.status == 'invited' ?
                    <Text theme='h1'>YOU HAVE BEEN INVITED</Text>
                    :<></>}
                    {group_player.status == 'active' ?
                    <Text theme='h1'>YOU ARE A MEMBER OF THIS GROUP</Text>
                    :<></>}
                    {group_player.status == 'inactive' ?
                    <Text theme='h1'>JOIN THIS GROUP NOW</Text>
                    :<></>}
                </View>
                :
                <View>                    
                    <Text theme='h1'>JOIN THIS GROUP NOW</Text>
                </View>
                }
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:5, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                {me && group_player?.status == 'invited' ?
                <Button
                    title='DECLINE'
                    type='error'
                    loading={action_loading}
                    style={{ flex:1, opacity: action_loading ? 0.5:1, margin:5 }}
                    disabled={action_loading}
                    onPress={() => handleDecline()}
                />
                :<></>}
                {me && group_player?.status == 'invited' ?
                <Button
                    title='ACCEPT'
                    type='success'
                    loading={action_loading}
                    style={{ flex:1, opacity: action_loading ? 0.5:1, margin:5 }}
                    disabled={action_loading}
                    onPress={() => handleAccept()}
                />
                :<></>}
                {me && group_player?.status == 'active' ?
                <Button
                    title='LEAVE GROUP'
                    type='error'
                    loading={action_loading}
                    style={{ flex:1, opacity: action_loading ? 0.5:1, margin:5 }}
                    disabled={action_loading}
                    onPress={() => handleLeave()}
                />
                :<></>}
                {!me ?
                <Button
                    title='SIGN IN / UP'
                    type='success'
                    loading={action_loading}
                    style={{ flex:1, opacity: action_loading ? 0.5:1, margin:5 }}
                    disabled={action_loading}
                    onPress={() => onRequestAuthenticate()}
                />
                :!group_player || group_player.status == 'inactive' ?
                <Button
                    title='JOIN GROUP'
                    type='success'
                    loading={action_loading}
                    style={{ flex:1, opacity: action_loading ? 0.5:1, margin:5 }}
                    disabled={action_loading}
                    onPress={() => handleJoin()}
                />
                :<></>}
            </View>
        </View>
    )
}

export default GroupPlayerActionForm